import { dayjs } from '../../../dayjs.ts'
import { useDistanceRangeHelpers } from '../../distance-range-helpers.ts'

// Builds a default report name such as `Test asset_3mi_20250801_120000_20250802_120000_reprocessed`
export const useDefaultReportName = () => {
	const radiusHelpers = useDistanceRangeHelpers()

	return ({
		locationNames,
		radiusKm,
		timezone,
		timeRange,
		suffixes = [],
	}: {
		locationNames: string[]
		radiusKm: number
		timezone: string
		timeRange?: { start: string; end: string }
		suffixes?: string[]
	}) => {
		const formatTime = (time: string) => dayjs(time).tz(timezone).format('YYYYMMDD_HHmmss')
		return [
			locationNames.toSorted().join(', '),
			radiusHelpers.formatKmInUserPreferenceUnit(radiusKm, '', 2),
			...(timeRange ? [formatTime(timeRange.start), formatTime(timeRange.end)] : []),
			...suffixes,
		].join('_')
	}
}
